import { PENDING, REJECTED, FULFILLED } from '../../helpers/reduxPromiseMiddleware'

import * as ActionTypes from '../../constants/ActionType'
import EntityFacade from '../../facades/entity'

export default {
  [ActionTypes.LOAD_VENUE]: {
    [PENDING](state, { payload }) {
      return EntityFacade(state)
        .startLoadingEntity('venues')
        .get()
    },
    [FULFILLED](state, { payload }) {
      const { venue } = payload
      return EntityFacade(state)
        .loadVenues(venue)
        .finishLoadingEntity('venues')
        .get()
    },
    [REJECTED](state, { payload }) {
      return EntityFacade(state)
        .loadVenues([])
        .finishLoadingEntity('venues')
        .get()
    }
  }
}
